/**
 * 通过公共库的资源格式，转换成 PT 上传后的文件格式
 */
export default function useCommonToExchangeFile(assetRes: any) {
  return {
    url: assetRes.file_url,
    origin_name: `${assetRes.name}.${assetRes.format}`,
    file_path: '',
    md5: assetRes.file_md5,
    res_id: assetRes.id,
    res_source: 'common',
  }
}
